import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { sharingQuetionService, deleteQuestionSharingService } from "../../services";

const ShareControlModal = ({ show, onHide, organizationId, controlQuestionId, shared_with_emails, onRefreshQuestions }) => {
  const [formData, setFormData] = useState({
    shared_with_email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [deleteError, setDeleteError] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Live validation
    if (name === "shared_with_email") {
      if (!value) {
        setErrors((prev) => ({
          ...prev,
          shared_with_email: "Email is required",
        }));
      } else if (!validateEmail(value)) {
        setErrors((prev) => ({
          ...prev,
          shared_with_email: "Enter a valid email address",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          shared_with_email: "",
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validateEmail(formData.shared_with_email)) {
      setErrors({
        shared_with_email: "Enter a valid email address",
      });
      return;
    }
  
    const payload = {
      organization_id: sessionStorage.getItem("organization_id"),
      control_question_id: controlQuestionId,
      shared_with_email: formData.shared_with_email,
      message: formData.message,
    };
  
    try {
      setLoading(true);
  
      const res = await sharingQuetionService(payload);

      console.log(res, 'resresresres')
  
      // ✅ Success check (API structure ke hisaab se adjust kar sakte ho)
      if (res?.statusCode?.status) {
        onHide();            // modal close
        setFormData({
          shared_with_email: "",
          message: "",
        });
        setErrors({});
      } else {
        setErrors({
          shared_with_email: res?.errors.message || "Something went wrong",
        });
      }
    } catch (error) {
      console.error("Share failed:", error);
      setErrors({
        shared_with_email: "Failed to share. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (questionSharingId) => {
    if (!questionSharingId) return;
    
    try {
      setDeletingId(questionSharingId);
      setDeleteError(""); // Clear previous error
      
      const res = await deleteQuestionSharingService(questionSharingId);
      
      if (res?.statusCode?.status) {
        setDeleteError(""); // Clear error on success
        // Refresh questions list after successful delete
        if (onRefreshQuestions) {
          onRefreshQuestions();
        }
        if (onHide) {
          onHide();
        }
      } else {
        setDeleteError(res?.errors?.message || res?.statusCode?.error?.message || "Failed to delete. Please try again.");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      setDeleteError(error?.response?.data?.message || error?.message || "Failed to delete. Please try again.");
    } finally {
      setDeletingId(null);
    }
  };
  

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Share Control</Modal.Title>
      </Modal.Header>

      {shared_with_emails.length > 0 && (
        <div className="p-3">
          <p >Shared With:</p>
          {deleteError && (
            <div className="alert alert-danger" role="alert">
              {deleteError}
            </div>
          )}
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {shared_with_emails.map((item, index) => (
              <li key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <span>{item.shared_with_email}</span>
                <span className="btn btn-danger btn-sm" style={{ cursor: 'pointer' }}
                  onClick={() => handleDelete(item.question_sharing_id)}
                  disabled={deletingId === item.question_sharing_id}>Remove</span>
              </li>
            ))}
          </ul>

          <hr />
        </div>
      )}

      <h5 className="ps-3">Add another email to share with</h5>
      <Form onSubmit={handleSubmit} noValidate>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="shared_with_email"
              placeholder="Enter email address"
              value={formData.shared_with_email}
              onChange={handleChange}
              isInvalid={!!errors.shared_with_email}
              required
            />
            <Form.Control.Feedback type="invalid">
              {errors.shared_with_email}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="message"
              placeholder="Enter message"
              value={formData.message}
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={loading || !!errors.shared_with_email}
          >
            {loading ? "Sharing..." : "Share"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ShareControlModal;
